import { EchartsWithTheme, Empty, useTheme } from '@maxtropy/components';
import { Skeleton } from 'antd';
import { FC, useRef } from 'react';
import { isNil } from 'lodash';
import { ChartItem } from '../../type';
import ResizeObserver from 'rc-resize-observer';
import { EchartsWithThemeRef } from '@maxtropy/components/es/components/EchartsWithTheme';

export interface ChartProps {
  loading?: boolean;
  chartData?: ChartItem[];
  option?: any;
  height?: number;
}

const Charts: FC<ChartProps> = props => {
  const { option, chartData, height } = props;
  const theme = useTheme();
  const chartRef = useRef<EchartsWithThemeRef>();
  const filteredChartData = chartData
    ?.map(c => c.chartValues?.filter(i => !isNil(i)))
    .filter(x => !isNil(x))
    .flat();

  return (
    <Skeleton style={{ padding: '120px 80px' }} loading={props.loading} paragraph={{ rows: 6 }}>
      <ResizeObserver
        onResize={({ width }) => {
          chartRef.current?.getInstance()?.resize({ width });
        }}
      >
        <EchartsWithTheme
          empty={{
            isShowEmpty: !(filteredChartData && filteredChartData.length),
            emptyNode: <Empty style={{ marginTop: 80 }} />,
          }}
          ref={e => {
            if (e) chartRef.current = e;
          }}
          option={option}
          style={{ height: height ?? 'calc(100vh - 520px)', minHeight: 440 }}
          theme={theme}
        />
      </ResizeObserver>
    </Skeleton>
  );
};

export default Charts;
